module.exports = __webpack_public_path__ + "img/点对齐-角标3.2d946df3.svg";